import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/constrainable/handle/styles.scss';export default {
  "handle": "_handle_1yx0w_1",
  "icon": "_icon_1yx0w_10",
  "leftHandler": "_leftHandler_1yx0w_16",
  "rightHandler": "_rightHandler_1yx0w_23"
};